import { createSelector } from '@reduxjs/toolkit';
export const stepsReducer = (state) => state.steps;
export const reduxStepstepsReducer = (state) => state.reduxSteps;
export const stepsSelector = createSelector(stepsReducer, (steps) => Object.values(steps.resources));
export const reduxStepsSelector = createSelector(reduxStepstepsReducer, (reducer) => reducer.data);
